export const getTaskIndex = (taskList: string[], taskId: string | null): number => {
	if (!taskList || taskId === null) {
		return -1;
	}
	return taskList.indexOf(taskId) + 1;
};
